import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserInterface } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class UserStore {
  private readonly _user$: BehaviorSubject<UserInterface | null> = new BehaviorSubject<UserInterface | null>(null);
  private readonly STORAGE_KEY = 'currentUser';

  constructor() {
    let initialValue = null;
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        initialValue = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error restoring User from sessionStorage', e);
    }

    this._user$ = new BehaviorSubject<UserInterface|null>(initialValue);
  }

  get user$(): Observable<UserInterface | null> {
    return this._user$.asObservable();
  }

  get user(): UserInterface | null {
    return this._user$.getValue();
  }

  set user(user: UserInterface | null) {
    if (user) {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(user));
    } else {
      sessionStorage.removeItem(this.STORAGE_KEY);
    }
    this._user$.next(user);
  }
}
